import { motion } from "framer-motion";
import { GALLERY } from "../../data/store";

export const Gallery = () => {
  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-[#12100E]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#A66E38] mb-3">
            Un vistazo
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-bold tracking-tight text-[#F5F0E6]">
            Nuestra Tienda
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-4">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden border border-white/5 ${g.span}`}
            >
              <img
                src={g.image}
                alt={g.label}
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0908]/85 via-transparent to-transparent" />
              <figcaption className="absolute bottom-4 left-4 font-serif text-lg md:text-xl text-[#F5F0E6] opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                {g.label}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
